import { FC, ReactNode, useRef, useState } from 'react'
import styles from './SplitRailShowcase.module.scss'
import cx from 'classnames'
import { OnRailsWrapper } from 'components/OnRailsWrapper'
import { useScrollPosition } from 'components/_hooks/useScrollPosition'
import { alarm, apps, autopilot, tracking } from 'components/SplitRailShowcase/_items'

export interface RailSlide {
	leftSide: ReactNode
	rightSide: ReactNode
}

export interface SplitRailProps {
	slides: RailSlide[]
	slideLength: number

	heading?: string
	subheading?: ReactNode
}

export const SplitRailLP: FC = () => {
	return (
		<SplitRailShowcase
			slides={[autopilot, alarm, tracking, apps]}
			slideLength={1000}
			heading={''}
			subheading={'Unlock the intelligence of the Pod for better sleep'}
		/>
	)
}

export const SplitRailShowcase: FC<SplitRailProps> = (props) => {
	const [activeSlide, setActiveSlide] = useState<number>(-1)
	const railsRef = useRef<HTMLDivElement>(null)

	const scrollPosition = useScrollPosition()

	if (railsRef.current) {
		const scrollToRailOffset = scrollPosition - railsRef.current.offsetTop
		const windowMidpoint = window.innerHeight / 2

		const slidePercent = (scrollToRailOffset + windowMidpoint) / props.slideLength
		const slideClamped = Math.max(0, Math.min(slidePercent, props.slides.length - 1))
		const slideRounded = Math.floor(slideClamped)

		if (slideRounded !== activeSlide) {
			setActiveSlide(slideRounded)
		}
	}

	return (
		<div>
			<div className={styles.header_container}>
				<p className={styles.pretty}>{props.heading}</p>
				<h2 className={styles.heading}>{props.subheading}</h2>
			</div>

			<div ref={railsRef} />

			{/* Desktop Rails */}
			<div className={styles.desktop_rails}>
				<div className={styles.text_rail}>
					{props.slides.map((slide, i) => (
						<OnRailsWrapper
							key={i}
							height={`${props.slideLength}px`}
							centered
						>
							<div
								className={styles.text_container}
								style={{
									opacity: activeSlide === i ? 1 : activeSlide > i ? 0.5 : 0,
								}}
							>
								{slide.leftSide}
							</div>
						</OnRailsWrapper>
					))}
				</div>

				<div className={styles.image_rail}>
					<OnRailsWrapper
						height={`${props.slides.length * props.slideLength}px`}
						centered
					>
						<div className={styles.image_container}>
							{props.slides.map((slide, i) => (
								<div
									key={i}
									className={cx(styles.sticky_img, { [styles.faded]: activeSlide !== i })}
								>
									{slide.rightSide}
								</div>
							))}
						</div>
					</OnRailsWrapper>
				</div>
			</div>

			{/* Mobile Rails */}
			<div className={styles.mobile_rails}>
				{props.slides.map((slide, i) => (
					<div
						className={styles.mobile_container}
						key={i}
					>
						{slide.rightSide}
						{slide.leftSide}
					</div>
				))}
			</div>
		</div>
	)
}
